import axios from 'axios';
import { appendTokenToUrl } from '../components/context/Recaptcha';
import { SECURITY_QUESTION_ESCROW_ENDPOINT } from '../components/constants';

const { config } = window.appAirDrop;
const { additionalHeaders, loginRootUrl } = config;

interface JSONObj {
  [key: string]: string;
}

function convertToUrlParams(params: JSONObj) {
  return Object.keys(params).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');
}

export async function sendMobileVerificationCodeForForgot(resetUnPwMobileData: any, recaptchaToken?: string) {
  const path = `${loginRootUrl}/login/sendMobileVerificationCodeForForgot`;
  const response = await axios.post(
    appendTokenToUrl(path, recaptchaToken),
    new URLSearchParams(resetUnPwMobileData).toString(),
    {
      headers: {
        ...(additionalHeaders ?? {}),
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      withCredentials: true,
    },
  );

  return response;
}

export async function getQuestions(resetUnPwMobileData: any) {
  const path = `${loginRootUrl}${SECURITY_QUESTION_ESCROW_ENDPOINT}`;
  const response = await axios.post(
    path,
    new URLSearchParams(resetUnPwMobileData).toString(),
    {
      headers: {
        ...(additionalHeaders ?? {}),
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      withCredentials: true,
    },
  );

  return response;
}

export async function validateSecurityQuestions(data: any, params: JSONObj, escrow: string) {
  const urlParams = convertToUrlParams(params);
  const path = `${loginRootUrl}/login/validateSecurityQuestions/${escrow}?${urlParams}`;
  const response = await axios.post(
    path,
    data,
    {
      headers: {
        ...(additionalHeaders ?? {}),
        'Content-Type': 'application/json; charset=UTF-8',
      },
      withCredentials: true,
    },
  );

  return response;
}
